// extracted by mini-css-extract-plugin
module.exports = {"component":"show-cards_component_3imSR","title":"show-cards_title_3b0xS","item-wrapper":"show-cards_item-wrapper_exFHv","item-wrapper--rows":"show-cards_item-wrapper--rows_3VStm"};